export default "./dist/stdassets/images/icons/icon_zoomselect.png";